import React, { useState, useRef, useEffect } from "react";
import Wrapper from "../UI/Wrapper";
import JSZip from "jszip";
import CryptoJS from "crypto-js";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Loader from "../../components/Loader/loader";
import search from "../../images/Search.png";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

const ExecutionDoc = ({ Priority_upload }) => {
  const [documentType, setDocumentType] = useState([]);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [decryptionError, setDecryptionError] = useState(false);
  const location = useLocation();
  const baseAPI = process.env.REACT_APP_API_URL;
  const [documentResponse, setDocumentResponse] = useState(null);
  const [leadDetailResponse, setLeadDetailResponse] = useState([]);
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const isAdmin = localStorage.getItem("isAdmin");
  const option = Priority_upload == "1" ? 3 : 2;
  const [documentsUpload, setDocumentsUpload] = useState({
    client_doc_id: "",
    relocation_id: "",
    document_type: "",
    remarkDoc: "",
    doc_path: "",
    doc_name: "",
    priority_upload: Priority_upload,
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}userget/GetLeadDetail?relocation_id=` + Relocation_ID, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setLeadDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      axios
        .get(
          `${baseAPI}userget/GetClientDocuments?relocation_id=` +
          Relocation_ID +
          `&option=${option}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setDocumentResponse(response.data.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      axios
        .get(`${baseAPI}userget/GetDocumentType?service_type=0&user_type=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          if (response) {
            setDocumentType(response.data.data.map((Name) => ({ Name })));
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  function handleChangeDoc(e) {
    const { name, value, files } = e.target;

    if (name === "doc_name") {
      const file = files[0];
      if (file.size > 50 * 1024 * 1024) {
        alert("File size exceeds 50 MB limit.");
        e.target.value = null;
        return;
      }

      if (isValidFileType(file)) {
        if (
          file.type === "application/zip" ||
          file.type === "application/x-zip-compressed"
        ) {
          validateZipFile(file, name, e);
        } else {
          getUpdatedImage(file, name);
        }
      } else {
        alert("Unsupported file type. Please upload a valid file.");
        // Reset the file input field
        e.target.value = null;
        return;
      }
    } else {
      setDocumentsUpload({
        ...documentsUpload,
        [name]: value,
      });
    }
  }

  function getUpdatedImage(file, name) {
    if (file) {
      setDocumentsUpload({
        ...documentsUpload,
        [name]: file, // Store the file object directly
      });
    }
  }

  function isValidFileType(file) {
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
      "application/vnd.ms-excel", // XLS
      "video/mp4",
      "video/x-msvideo", // AVI
      "video/x-matroska", // MKV
      "video/quicktime", // MOV
      "application/zip", // ZIP
      "application/x-zip-compressed", // Alternate ZIP MIME type
    ];
    return file && allowedTypes.includes(file.type);
  }

  function validateZipFile(file, name, e) {
    const reader = new FileReader();
    reader.onload = function (event) {
      const zipData = event.target.result;

      // Perform ZIP content validation here
      // This might include extracting the files, verifying file types, etc.
      // Client-side libraries like JSZip can help inspect ZIP files
      try {
        const jszip = new JSZip();
        jszip.loadAsync(zipData).then((zip) => {
          const allowedExtensions = ["jpg", "png", "pdf", "docx", "xlsx"];
          let isValid = true;

          zip.forEach((relativePath, zipEntry) => {
            const extension = relativePath.split(".").pop().toLowerCase();
            if (!allowedExtensions.includes(extension)) {
              isValid = false;
            }
          });

          if (isValid) {
            getUpdatedImage(file, name);
          } else {
            alert("ZIP file contains unsupported file types.");
            e.target.value = null;
          }
        });
      } catch (error) {
        alert("Error reading ZIP file.");
        e.target.value = null;
      }
    };

    reader.readAsArrayBuffer(file);
  }

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);
      setDecryptionError(true);

      return null;
    }
  }

  function getDocument(Relocation_ID) {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetClientDocuments?relocation_id=` +
          Relocation_ID +
          `&option=${option}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setDocumentResponse(response.data.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  const uploadDocument = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);

    // Append form fields and the file to FormData
    formData.append("relocation_id", Relocation_ID);
    formData.append("document_type", documentsUpload.document_type);
    formData.append("remarkDoc", documentsUpload.remarkDoc);
    formData.append("priority_upload", documentsUpload.priority_upload);

    // Ensure the file itself is being sent
    formData.append("doc_name", documentsUpload.doc_name); // This will now be the file object

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}userpost/UploadClientPdfData`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "multipart/form-data", // Ensure you're sending form data
          },
        }
      );

      // Reset after success
      setDocumentsUpload({
        relocation_id: "",
        document_type: "",
        remarkDoc: "",
        doc_path: "",
        doc_name: "",
        priority_upload: Priority_upload,
      });

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      getDocument(Relocation_ID);
    } catch (error) {
      console.error("Error posting data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc"); // Default sort order is ascending

  const sortAndToggleOrder = (column) => {
    // Determine the new sort order
    const newSortOrder =
      sortedColumn !== column || sortOrder === "desc" ? "asc" : "desc";

    let sortedData = [...documentResponse];
    // Sorting logic here (adjusted to use newSortOrder)
    if (column === "document_type") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    }
    setDocumentResponse(sortedData);
    setSortedColumn(column);
    setSortOrder(newSortOrder);
  };

  async function deleteDoc(client_doc_id) {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this document?"
    );
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);
    if (isConfirmed) {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.delete(
        `${baseAPI}userpost/DeleteClientDocs`,
        {
          data: { client_doc_id: client_doc_id }, // Send request body
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      getDocument(Relocation_ID);
    }
  }

  async function submitDocument(client_doc_id) {
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}userpost/SubmitClientDocument`,
        { client_doc_id: client_doc_id },
        {
          // Send request body
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      getDocument(Relocation_ID);
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  }

const [visibleTo, setVisibleTo] = useState("");

  // Handle dropdown selection
  const handleVisibleToChange = (e) => {
    const value = e.target.value;
    setVisibleTo(value);

    let updatedPriority;
    if (value === "customer") updatedPriority = "3";
    else if (value === "sales") updatedPriority = "2";
    else if (value === "operation") updatedPriority = "1";

    setDocumentsUpload((prev) => ({
      ...prev,
      priority_upload: updatedPriority,
    }));
  };


  return (
    <>
      <div>
        <div>
          <Wrapper className="LeadDetails">
            {/* ----------------------------------Upload Documents-------------------------------------- */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                // alignItems: "flex-end",
              }}
            >
              <div className="viewLeadDetails-form" style={{ border: "none" }}>
                <table
                  style={{
                    width: "100%",
                    color: "#6A6A6A",
                    borderRadius: "5px",
                  }}
                >
                  <tr>
                    <td colSpan={2}>
                      <table style={{ width: "100%" }}>
                        <tr className="viewLeadDetailsHeading">
                          <th
                            style={{
                              background: "#5B489D",
                              color: "white",
                              fontWeight: "bold",
                              width: "87%",
                              borderRight: "1px solid white",
                              // borderTopRightRadius: "1px",
                              // borderBottomRightRadius: "1px",
                            }}
                          >
                            <span style={{ fontSize: "18px" }}>
                              {" "}
                              Upload Documents{" "}
                            </span>
                          </th>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      <p style={{ color: "red" }}>
                        Note*: Once uploaded, documents must be submitted. After
                        submission, they cannot be deleted and will be visible
                        to all users. Please review carefully before submitting.
                      </p>
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td colSpan={2}></td>
                  </tr>

                  {Priority_upload === "1" && (
                    <tr >
                      <td colSpan={2}>
                        <span>
                          {" "}
                          <b>Document Visible To</b>
                        </span>
                        <br />
                        <select value={visibleTo} onChange={handleVisibleToChange}  className="form-control" >
                          <option value="">Select</option>
                          <option value="customer">Customer (Visible To All) </option>
                          <option value="sales">Sales (Visible To Sales and Operations) </option>
                          <option value="operation">Operation (Visible only to Operations)  </option>
                        </select>

                      </td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <span>
                        {" "}
                        <b>Document Type</b>
                      </span>
                      <br />
                      <select
                        id="document_type"
                        className="form-control"
                        name="document_type"
                        onChange={handleChangeDoc}
                        value={documentsUpload.document_type}
                      >
                        <option value="0">Select an option</option>
                        {documentType.map((item, index) => (
                          <option key={index}>{item.Name}</option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <span>
                        <b>Choose Document</b>{" "}
                      </span>
                      <br />
                      <input
                        id="doc_name"
                        type="file"
                        name="doc_name"
                        onChange={handleChangeDoc}
                        ref={fileInputRef}
                        required
                        className="form-control"
                        style={{ width: "-webkit-fill-available" }}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <span>
                        {" "}
                        <b>Any Remark </b>
                      </span>
                      <br />
                      <input
                        id="remarkDoc"
                        type="text"
                        name="remarkDoc"
                        onChange={handleChangeDoc}
                        value={documentsUpload.remarkDoc}
                        placeholder="Please Enter*"
                        className="form-control"
                        style={{ width: "175%" }}
                      />
                    </td>

                    <td style={{ textAlign: "end" }}>
                      &nbsp; <br />
                      <button
                        style={{
                          backgroundColor: "#5B489D",
                          color: "white",
                          width: "21%",
                          margin: "7px",
                        }}
                        className="btn btn-success inputDoc3"
                        onClick={uploadDocument}
                      >
                        Upload
                      </button>
                    </td>
                  </tr>
                </table>
              </div>

              <br />

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <div className="viewLeadDetails-form">
                  <table
                    style={{
                      width: "100%",
                      color: "#6A6A6A",
                      borderRadius: "5px",
                    }}
                  >
                    <tr>
                      <td colSpan={4}>
                        <table style={{ width: "100%" }}>
                          <tr className="viewLeadDetailsHeading">
                            <th
                              style={{
                                background: "#5B489D",
                                color: "white",
                                fontWeight: "bold",
                                width: "87%",
                                borderRight: "1px solid white",
                                borderTopRightRadius: "1px",
                                borderBottomRightRadius: "1px",
                              }}
                            >
                              <span style={{ fontSize: "18px" }}>
                                {" "}
                                Documents{" "}
                              </span>
                            </th>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr className="viewLeadDetailsHeading">
                      <th>
                        <span>Customer Name</span>
                      </th>
                      <td>
                        <span>{leadDetailResponse.first_name}</span>
                      </td>
                      <th>
                        <span>Lead Owner</span>
                      </th>
                      <td>
                        <span>{leadDetailResponse.name}</span>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <table
                  className="customerDetailsTable"
                  style={{ width: "99%", marginLeft: "5px" }}
                >
                  <div className="undefined" style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          padding: "11px 0 0 0",
                          
                        }}
                      >
                        {loading ? (
                          <div style={{ position: "relative", left: "540px" }}>
                            <Loader />
                          </div>
                        ) : (
                          <table>
                            <tr className="docUpload">
                              <th style={{ width: "5%" }}>Sr No.</th>
                              <th
                                style={{ width: "20%" }}
                                onClick={() =>
                                  sortAndToggleOrder("document_type")
                                }
                              >
                                Document Type
                                {sortedColumn === "document_type" && (
                                  <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                                )}
                              </th>
                              <th style={{ width: "20%" }}>
                                Upload Date and Time
                              </th>
                              <th style={{ width: "20%" }}>Uploaded By</th>
                              <th style={{ width: "25%" }}>Remark</th>
                              <th style={{ width: "10%" }}>Review</th>
                              <th style={{ width: "10%" }}>Status</th>
                            </tr>
                            {documentResponse !== null
                              ? documentResponse.map((item, index) => (
                                <tr className="documentTable">
                                  <td style={{ width: "5%" }}>{++index}</td>
                                  <td style={{ width: "20%" }}>
                                    {item.document_type}
                                  </td>
                                  <td style={{ width: "20%" }}>
                                    {new Intl.DateTimeFormat("en-GB", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    }).format(new Date(item.created_date))}
                                  </td>
                                  <td style={{ width: "20%" }}>
                                    {item.added_by}
                                  </td>
                                  <td style={{ width: "25%" }}>
                                    {item.remarkDoc}
                                  </td>

                                  <td style={{ width: "10%", display: "flex", marginTop: "9px" }}>
                                    <a
                                      style={{
                                        color: "#6a6a6a",
                                        textDecoration: "none",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                      }}
                                      target="_blank"
                                      href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}`}
                                      rel="noopener noreferrer"
                                    >
                                      <img src={search} alt="search" />
                                    </a>
                                    {item.isSubmit === 0 ||
                                      isAdmin === "true" ? (
                                      <button
                                        onClick={() =>
                                          deleteDoc(item.client_doc_id)
                                        }
                                        style={{
                                          height: "30px",
                                          width: "35px",
                                          marginLeft: "5px",
                                          backgroundColor: "#F4616F",
                                          borderColor: "#FF0000",
                                        }}
                                      >
                                        <DeleteOutlinedIcon className="icon" />
                                      </button>
                                    ) : null}
                                  </td>
                                  <td>
                                    {item.isSubmit === 0 ? (
                                      <button
                                        style={{
                                          backgroundColor: "#DD4477",
                                          color: "white",
                                          width: "82%",
                                          margin: "7px",
                                          fontWeight: "bold",
                                        }}
                                        className="btn btn-success inputDoc3"
                                        onClick={() =>
                                          submitDocument(item.client_doc_id)
                                        }
                                      >
                                        Submit
                                      </button>
                                    ) : (
                                      <button
                                        style={{
                                          backgroundColor: "#04B35A",
                                          color: "white",
                                          width: "82%",
                                          margin: "7px",
                                          fontWeight: "bold",
                                          cursor: "default",
                                        }}
                                        className="btn btn-success inputDoc3"
                                      >
                                        Submitted
                                      </button>
                                    )}
                                  </td>
                                </tr>
                              ))
                              : null}
                          </table>
                        )}
                      </div>
                    </div>
                  </div>
                </table>
              </div>
            </div>
          </Wrapper>
          <br />
        </div>
      </div>
    </>
  );
};

export default ExecutionDoc;
